import React from 'react'
import Grievance from '../components/Grievance'
import Footer from '../components/Footer'
import Navbar from '../components/Navbar'
import Sidebar from '../components/Sidebar'
import Warning from '../components/Warning'
import Banner from "../components/Banner";
const GrievancePage = () => {
  return (
    <>
      <section className="hidden lg:block">
         <Banner />
        <Navbar />
      <Warning/>

      </section>
      <section className="block lg:hidden">
        <Sidebar />
      </section>
      <Grievance />
      <Footer/>
    </>
  )
}

export default GrievancePage